import { createProxy } from '../toolkit/proxy';
export const initialState = {
  total: 0,
  offset: 0,
  filter: '',
  sortBy: 'createdAt',
  context: null,
  filters: [],
  rowsData: [],
  lastUpdated: new Date(),
  isLoading: true,
  isFetchMore: false,
  totalToday: 0,
  currentPage: 0,
  headerProps: [],
  sortDirection: 'desc',
  severeThisWeek: 0,
  predefinedFilters: [],
  isDownloadingCsv: false,
  virtualScroll: false
};

/** @deprecated use auditLogs instead of audits */
export default (overrideState => createProxy(initialState, overrideState));